/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  FaBars, FaCircle, FaAngleDown, FaAngleUp,
} from 'react-icons/fa';

import LogoUrl from '../../assets/images/logo@2x.png';
import defaultAvatar from '../../assets/images/default-avatar-store.png';

import {
  Header,
  Logo,
  ToggleButton,
  NavBar,
  StoreInfo,
  Avatar,
} from './styles';
import { Container } from '../../assets/styles';

const HeaderComponent = ({
  drawerHandler,
  openStoreAvailabilityModal,
  dropdown,
  showDropdownMenu,
  store,
}) => (
  <Header>
    <Container style={{ display: 'flex', alignItems: 'center' }}>
      {store.id && (
        <ToggleButton onClick={() => drawerHandler()}>
          <FaBars className="fa fa-bars" />
        </ToggleButton>
      )}
      <NavLink to="/dashboard/home">
        <Logo src={LogoUrl} alt="Logo Reforma Fácil" />
      </NavLink>
      {store.id && (
        <>
          <NavBar roleType={store.roleType}>
            <ul>
              {store.roleType !== 'employee' && <li><NavLink to="/dashboard/home" activeClassName="active">Início</NavLink></li>}
              <li><NavLink to="/dashboard/orders" activeClassName="active">Pedidos</NavLink></li>
              <li><NavLink to="/dashboard/products" activeClassName="active">Materiais</NavLink></li>
              {store.roleType !== 'employee' && <li><NavLink to="/dashboard/billing" activeClassName="active">Financeiro</NavLink></li>}
              <li><NavLink to="/dashboard/ratings" activeClassName="active">Avaliações</NavLink></li>
              {store.roleType !== 'employee' && <li><NavLink to="/dashboard/store/account" activeClassName="active">Minha loja</NavLink></li>}
            </ul>
          </NavBar>
          <StoreInfo
            roleType={store.roleType}
            available={store.status.available}
            blocked={store.status.blocked}
          >
            <Avatar src={store.avatarUrl || defaultAvatar} />
            <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
              <h2>{store.name}</h2>
              <button type="submit" className="store-available" onClick={() => (store.roleType !== 'employee' && store.status.published && !store.status.blocked ? openStoreAvailabilityModal() : null)}>
                {store.status.available && store.status.open && !store.status.blocked && <FaCircle className="fa fa-circle" />}
                {store.status.available && !store.status.open && !store.status.blocked && <FaCircle className="fa fa-circle closed" />}
                {(!store.status.available || store.status.blocked) && <FaCircle className="fa fa-circle unavailable" />}
                {store.status.available && !store.status.blocked && <span>Disponível</span>}
                {(!store.status.available && !store.status.blocked) && <span>Indisponível</span>}
                {store.status.blocked && <span>Bloqueado</span>}
              </button>
            </div>
            {!dropdown && <FaAngleDown className="fa fa-angle-down" onClick={() => showDropdownMenu()} />}
            {dropdown && <FaAngleUp className="fa fa-angle-up" onClick={() => showDropdownMenu()} />}
          </StoreInfo>
        </>
      )}
    </Container>
  </Header>
);

export default HeaderComponent;
